import { Action } from '@ngrx/store';

export const GET_OPTION_GROUPS_CONFIG = 'GET_OPTION_GROUPS_CONFIG';
export const GET_OPTION_GROUPS_CONFIG_SUCCESS =
  'GET_OPTION_GROUPS_CONFIG_SUCCESS';

export const GET_OPTIONS_CATEGORIES_CONFIG = 'GET_OPTIONS_CATEGORIES_CONFIG';
export const GET_OPTIONS_CATEGORIES_CONFIG_SUCCESS =
  'GET_OPTIONS_CATEGORIES_CONFIG_SUCCESS';

export const GET_SETTINGS_CATEGORIES_CONFIG = 'GET_SETTINGS_CATEGORIES_CONFIG';
export const GET_SETTINGS_CATEGORIES_CONFIG_SUCCESS =
  'GET_SETTINGS_CATEGORIES_CONFIG_SUCCESS';

export const GET_FREE_VOD_CONFIG = 'GET_FREE_VOD_CONFIG';
export const GET_FREE_VOD_CONFIG_SUCCESS = 'GET_FREE_VOD_CONFIG_SUCCESS';

export const GET_SETTINGS_CTA_FILTER_CONFIG = 'GET_SETTINGS_CTA_FILTER_CONFIG';
export const GET_SETTINGS_CTA_FILTER_CONFIG_SUCCESS = 'GET_SETTINGS_CTA_FILTER_CONFIG_SUCCESS';

export class GetOptionGroupsConfig implements Action {
  type = GET_OPTION_GROUPS_CONFIG;

  constructor(public payload?: any) {}
}

export class GetOptionGroupsConfigSuccess implements Action {
  type = GET_OPTION_GROUPS_CONFIG_SUCCESS;

  constructor(public payload: any) {}
}

export class GetOptionsCategoriesConfig implements Action {
  type = GET_OPTIONS_CATEGORIES_CONFIG;

  constructor(public payload?: any) {}
}

export class GetOptionsCategoriesConfigSuccess implements Action {
  type = GET_OPTIONS_CATEGORIES_CONFIG_SUCCESS;

  constructor(public payload?: any) {}
}

export class GetSettingsCategoriesConfig implements Action {
  type = GET_SETTINGS_CATEGORIES_CONFIG;

  constructor(public payload?: any) {}
}

export class GetSettingsCategoriesConfigSuccess implements Action {
  type = GET_SETTINGS_CATEGORIES_CONFIG_SUCCESS;

  constructor(public payload?: any) {}
}

export class GetFreeVodConfig implements Action {
  type = GET_FREE_VOD_CONFIG;

  constructor(public payload?: any) {}
}

export class GetFreeVodConfigSuccess implements Action {
  type = GET_FREE_VOD_CONFIG_SUCCESS;

  constructor(public payload?: any) {}
}

export class GetSettingsCtaFilterConfig implements Action {
  type = GET_SETTINGS_CTA_FILTER_CONFIG;

  constructor(public payload?: any) {}
}

export class GetSettingsCtaFilterConfigSuccess implements Action {
  type = GET_SETTINGS_CTA_FILTER_CONFIG_SUCCESS;

  constructor(public payload?: any) {}
}

export type Actions =
  | GetOptionGroupsConfig
  | GetOptionGroupsConfigSuccess
  | GetOptionsCategoriesConfig
  | GetOptionsCategoriesConfigSuccess
  | GetSettingsCategoriesConfig
  | GetSettingsCategoriesConfigSuccess
  | GetFreeVodConfig
  | GetFreeVodConfigSuccess
  | GetSettingsCtaFilterConfig
  | GetSettingsCtaFilterConfigSuccess;
